import { render, staticRenderFns } from "./TrendProductCard.vue?vue&type=template&id=34a8e7e9&scoped=true"
import script from "./TrendProductCard.vue?vue&type=script&lang=js"
export * from "./TrendProductCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a8e7e9",
  null
  
)

export default component.exports